import * as util from './utilitys';
import _ from 'lodash';

export const getPrimaryKey = (inputs) => {
    return Object.keys(inputs).filter(
        key => inputs[key].validator?.type === 'primaryKey'
    );
}

export const getRowIdStart = (pagination) => {
    const { currentPage, pageSize } = pagination;
    return (currentPage - 1) * pageSize;
}

export const getInputSearch = (searchState, paginationState) => {
    return Object.keys(searchState).reduce((acc, key) => {
        acc[searchState[key].id] = String(searchState[key].value);
        return acc;
    }, {});
};

export const getInputForm = (inputState) => {
    return Object.keys(inputState).reduce((acc, key) => {
        const { id, value, type, file } = inputState[key];
        acc[id] = {
            value: type === 'file' && file instanceof File ? file : String(value),
            type
        };
        return acc;
    }, {});
};

export const getParameterPrompt = (Parameters, current, key) => {
    // console.log(Parameters, current, key);
    const elements = Parameters?.[current]?.parameters?.element;
    if (!Array.isArray(elements)) return undefined;

    return elements.find(item => item.id === key);
}

export const setRequiredPrimaryKey = (Inputs, isUpdateMode) => {
    return Object.keys(Inputs).reduce((acc, key) => {
        const input = Inputs[key];

        acc[key] = input?.validator?.type === 'primaryKey'
            ? { ...input, validator: { ...input.validator, required: isUpdateMode } }
            : input;

        return acc;
    }, {});
}

export const setInputValueByKey = (Inputs, key, value) => {
    if (!Inputs?.[key]) return Inputs; 

    return {
        ...Inputs,
        [key]: {
            ...Inputs[key],
            value
        }
    };
}
/** 
export const shouldPrepareInputs = (prevAction, currAction) => {
    const modeChanged = prevAction.Mode !== currAction.Mode;
    const enteredOffCanvasNew =
        prevAction.OffCanvas?.mode !== 'new' &&
        (currAction.OffCanvas?.mode === 'new')  &&
        currAction.OffCanvas?.show === true;

    return modeChanged && enteredOffCanvasNew;
};
*/
export const shouldPrepareInputs = (prevAction, currAction) => {
    const modeChanged = prevAction.Mode !== currAction.Mode;

    const enteredOffCanvasNew =
        prevAction.OffCanvas?.mode !== 'new' &&
        currAction.OffCanvas?.mode === 'new' &&
        currAction.OffCanvas?.show === true;

    const isUpdateMode = currAction.Mode === 'update';

    const inputsChanged =
        !_.isEqual(prevAction.Inputs, currAction.Inputs); // Deep compare

    return (
        (modeChanged && enteredOffCanvasNew) ||
        (modeChanged && isUpdateMode) ||
        (isUpdateMode && inputsChanged)
    );
};

export const validateInput = (validator, value, name="" , inputs={}, inputGroup={}) => {
  let result = { status: false, msg: '' };

  if (!validator || !validator.type) {
      return { status: true, msg: 'ไม่ทราบชนิดข้อมูล' };
  }
  switch (validator.type) {

        case 'primaryKey':
            if (validator.required && (!value || value.trim() === '')) {
                return { status: true, msg: 'ไม่อนุญาตให้เป็นค่าว่าง' };
            }
            if (validator.required && validator.minLength && value.length < validator.minLength) {
                return { status: true, msg: `กรุณากรอกอย่างน้อย ${validator.minLength} ตัวอักษร` };
            }
            if (validator.required && validator.maxLength && value.length > validator.maxLength) {
                return { status: true, msg: `ไม่อนุญาตให้ความยาวเกินจำนวน ${validator.maxLength} ตัวอักษร` };
            }
        break;

        case 'text':
            if (validator.required && (!value || value.trim() === '')) {
                return { status: true, msg: 'ไม่อนุญาตให้เป็นค่าว่าง' };
            }
            if (validator.required && validator.minLength && value.length < validator.minLength) {
                return { status: true, msg: `กรุณากรอกอย่างน้อย ${validator.minLength} ตัวอักษร` };
            }
            if (validator.required && validator.maxLength && value.length > validator.maxLength) {
                return { status: true, msg: `ไม่อนุญาตให้ความยาวเกินจำนวน ${validator.maxLength} ตัวอักษร` };
            }
            break;

            case 'number':
                const numberRegex = /^-?\d*\.?\d*$/; 
                if (!numberRegex.test(value)) {
                    return { status: true, msg: 'รูปแบบตัวเลขไม่ถูกต้อง' };
                }
            
                const numericValue = parseFloat(value);
            
                if (isNaN(numericValue)) {
                    return { status: true, msg: 'ค่าต้องเป็นตัวเลข' };
                }
            
                if (validator.min !== undefined && numericValue < validator.min) {
                    return { 
                        status: true, 
                        msg: `ค่าต้องไม่น้อยกว่า ${util.formatNumber(validator.min)}` 
                    }; 
                }
            
                if (validator.max !== undefined && numericValue > validator.max) {
                    return { 
                        status: true, 
                        msg: `ค่าต้องไม่เกิน ${util.formatNumber(validator.max)}` 
                    }; 
                }
                break;

        case 'date':
            const dateRegex = /^(\d{4}-\d{2}-\d{2}|\d{2}\/\d{2}\/\d{4}|\d{2}-\d{2}-\d{4})$/;
            if (!dateRegex.test(value)) {
                return { status: true, msg: 'รูปแบบวันที่ไม่ถูกต้อง' };
            }
            break;

        case 'email':
            const emailRegex = /^[\w.-]+@[\w.-]+\.\w{2,}$/;
            if (!emailRegex.test(value)) {
                return { status: true, msg: 'รูปแบบอีเมล์ไม่ถูกต้อง' };
            }
            break;

        case 'radio':
            if (validator.required && (!value || value.trim() === '')) {
                return { status: true, msg: 'กรุณาเลือกตัวเลือก' };
            }
            break;
        
        case 'checkbox':
            let checkboxInputs = inputGroup.Checkbox[inputs[name].group].inputs; 
            let checkboxValidator = inputGroup.Checkbox[inputs[name].group].validator;

            let isAnyChecked = checkboxInputs.some(item => {
                let id = item.id; 
                let checkboxValue = inputs[id]?.value; 
                let isChecked = checkboxValue && checkboxValue !== '';
                return isChecked;
            });
            
            if (checkboxValidator.required) {
                if (!isAnyChecked) {
                    return { status: true, msg: 'กรุณาเลือกอย่างน้อย 1 รายการ' };
                }
            }
            break;
        
        case 'file':
            if (
                validator.required &&
                (
                  (!inputs.file || !inputs.file.name || inputs.file.name.trim().length === 0) &&
                  util.isEmpty(inputs.fileId)
                )
            ) { return { status: true, msg: 'กรุณาอัปโหลดไฟล์' }; }

            if (validator.accept && inputs.file && typeof inputs.file.name === 'string') {
                const allowedTypes = validator.accept
                    .split(',')
                    .map(type => type.trim().toLowerCase());
            
                const fileName = inputs.file.name.toLowerCase();
                const fileExtension = fileName.includes('.') ? `.${fileName.split('.').pop()}` : '';
                const mimeType = (inputs.file.type || '').toLowerCase();
            
                const isValid = allowedTypes.some(type =>
                    type.startsWith('.') ? fileExtension === type : mimeType === type
                );
            
                if (!isValid) {
                    return {
                        status: true,
                        msg: `อนุญาตให้อัปโหลดไฟล์เฉพาะ: ${allowedTypes.join(', ')}`
                    };
                }
            }
            
            break;

        default:
            return { status: true, msg: 'ไม่ทราบชนิดข้อมูล' };
  }

  return result;
};

/** 
export const allInputValidatorCheck = (inputs, inputGroup) => {
    return Object.entries(inputs).every(([name, input]) => {
        let isValid = false;

        if (input.type === 'checkbox' && input.group) {
            const groupName = input.group;
            const groupData = inputGroup?.Checkbox?.[groupName];

            if (groupData?.validator?.required === true) {
                isValid = groupData.error?.status === null || groupData.error?.status === false;
                console.log(`Checkbox Group: ${name}, isValid: ${isValid}`);
                return isValid;
            }
        }

        if (input.type === 'file' && input.validator?.required === true) {
            const value = input.value || input.fileId || "";
            isValid = (
                (input.error.status === null || input.error.status === false) &&
                String(value).trim() !== ""
            );
            console.log(`File: ${name}, value: ${String(value)}, isValid: ${isValid}`);
            return isValid;
        }

        if (input.validator?.required === true) {
            const value = input.value ?? "";
            isValid = (
                (input.error.status === null || input.error.status === false) &&
                String(value).trim() !== ""
            );
            console.log(`Required Field: ${name}, value: ${String(value)}, isValid: ${isValid}`);
            return isValid;
        }

        // console.log(">>>>", input.id);
        isValid = input.error.status === null || input.error.status === false;
        console.log(`Optional Field: ${name}, isValid: ${isValid}`);
        return isValid;
    });
};

export const allInputValidatorCheck = (inputs, inputGroup) => {
    const invalidRequiredInputs = [];

    const allValid = Object.entries(inputs).every(([name, input]) => {
        let isValid = true;

        // Validate checkbox group
        if (input.type === 'checkbox' && input.group) {
            const groupName = input.group;
            const groupData = inputGroup?.Checkbox?.[groupName];

            if (groupData?.validator?.required === true) {
                isValid = groupData.error?.status === null || groupData.error?.status === false;
                if (!isValid) {
                    invalidRequiredInputs.push({ name, reason: 'Checkbox group invalid or unselected' });
                }
                return isValid;
            }
        }

        // Validate required file
        if (input.type === 'file' && input.validator?.required === true) {
            const value = input.value || input.fileId || "";
            isValid = (
                (input.error?.status === null || input.error?.status === false) &&
                String(value).trim() !== ""
            );
            if (!isValid) {
                invalidRequiredInputs.push({ name, reason: 'Required file is missing or invalid' });
            }
            return isValid;
        }

        // Validate other required fields
        if (input.validator?.required === true) {
            const value = input.value ?? "";
            isValid = (
                (input.error?.status === null || input.error?.status === false) &&
                String(value).trim() !== ""
            );
            if (!isValid) {
                invalidRequiredInputs.push({ name, reason: 'Required value is empty or invalid' });
            }
            return isValid;
        }

        // Optional fields
        isValid = input.error?.status === null || input.error?.status === false;
        return isValid;
    });

    if (invalidRequiredInputs.length > 0) {
        console.warn("Invalid Required Inputs:", invalidRequiredInputs);
        return false;
    }

    return allValid;
};

export const allInputValidatorCheck = (inputs, inputGroup) => {
  const invalidRequiredInputs = [];

  const allValid = Object.entries(inputs).every(([name, input]) => {
    let isValid = true;

    if (input.type === "checkbox" && input.group) {
      const groupName = input.group;
      const groupData = inputGroup?.Checkbox?.[groupName];

      if (groupData?.validator?.required === true) {
        isValid = groupData.error?.status === null || groupData.error?.status === false;
        if (!isValid) {
          invalidRequiredInputs.push({ name, reason: "Checkbox group invalid or unselected" });
        }
        return isValid;
      } else {
        return true;
      }
    }

    if (input.type === "file" && input.validator?.required === true) {
      const value = input.value || input.fileId || "";
      isValid =
        (input.error?.status === null || input.error?.status === false) &&
        String(value).trim() !== "";
      if (!isValid) {
        invalidRequiredInputs.push({ name, reason: "Required file is missing or invalid" });
      }
      return isValid;
    }

    if (input.validator?.required === true) {
      const value = input.value ?? "";
      isValid =
        (input.error?.status === null || input.error?.status === false) &&
        String(value).trim() !== "";
      if (!isValid) {
        invalidRequiredInputs.push({ name, reason: "Required value is empty or invalid" });
      }
      return isValid;
    }

    isValid = input.error?.status === null || input.error?.status === false;
    return isValid;
  });

  if (invalidRequiredInputs.length > 0) {
    console.warn("Invalid Required Inputs:", invalidRequiredInputs);
    return false;
  }

  return allValid;
};
*/

export const allInputValidatorCheck = (inputs, inputGroup) => {
  const invalidRequiredInputs = [];

  Object.entries(inputs).forEach(([name, input]) => {
    let isValid = true;

    // ---- CHECKBOX GROUP ----
    if (input.type === "checkbox" && input.group) {
      const groupName = input.group;
      const groupData = inputGroup?.Checkbox?.[groupName];

      if (groupData?.validator?.required === true) {
        isValid = groupData.error?.status === null || groupData.error?.status === false;
        if (!isValid) {
          console.log("❌ Invalid checkbox group:", {
            field: name,
            groupName,
            error: groupData?.error
          });
          invalidRequiredInputs.push({ name, reason: "Checkbox group invalid or unselected" });
        }
      }
    }

    // ---- FILE INPUT ----
    else if (input.type === "file" && input.validator?.required === true) {
      const value = input.value || input.fileId || "";
      isValid =
        (input.error?.status === null || input.error?.status === false) &&
        String(value).trim() !== "";
      if (!isValid) {
        console.log("❌ Invalid file input:", {
          field: name,
          type: input.type,
          value,
          error: input.error
        });
        invalidRequiredInputs.push({ name, reason: "Required file is missing or invalid" });
      }
    }

    // ---- GENERAL REQUIRED ----
    else if (input.validator?.required === true) {
      const value = input.value ?? "";
      isValid =
        (input.error?.status === null || input.error?.status === false) &&
        String(value).trim() !== "";
      if (!isValid) {
        console.log("❌ Invalid required field:", {
          field: name,
          type: input.type,
          value,
          error: input.error
        });
        invalidRequiredInputs.push({ name, reason: "Required value is empty or invalid" });
      }
    }

    // ---- NON-REQUIRED BUT STILL HAS ERROR ----
    else {
      isValid = input.error?.status === null || input.error?.status === false;
      if (!isValid) {
        console.log("❌ Invalid non-required field:", {
          field: name,
          type: input.type,
          value: input.value,
          error: input.error
        });
        invalidRequiredInputs.push({ name, reason: "Field has error" });
      }
    }
  });

  if (invalidRequiredInputs.length > 0) {
    console.warn("⚠️ Some inputs are invalid:", invalidRequiredInputs);
    return false;
  }

  console.log("✅ All inputs are valid");
  return true;
};


    
export const getCheckboxAllItem = (name) => {
   const checkboxes = document.querySelectorAll(`input[name="${name}"]`);
    
   return Array.from(checkboxes).map(checkbox => ({
       value: checkbox.value,  
       checked: checkbox.checked,
   }));
};
